import React from 'react';
import PropTypes from 'prop-types';

import Description from "ui/text/Description";
import Button from 'ui/Button';

import isMobileDevice from "utils/mobileAndTabletCheck";

const shortLabels = ["S", "M", "T", "W", "T", "F", "S"];
const abbreviatedLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const WeekdaySelector = ({event, onEventChange, setUnsavedChanges}) => {

    const days = isMobileDevice() ? shortLabels : abbreviatedLabels;

    const { repeat_days, start_time } = event;

    // Pill semantics:
    //   - unselected day  -> add first entry for that wday
    //   - selected day with exactly one entry -> remove it (toggle-off, single-slot case)
    //   - selected day with multiple entries  -> no-op (prevents accidental mass-clear;
    //     remove individual slots from SessionTimesEditor's per-row delete control)
    // Multi-slot addition lives in SessionTimesEditor's "+" affordance, which only
    // renders when universal_time === false.
    const handleRepeatDay = (value) => {
        setUnsavedChanges(true);

        const wday = value.toString();
        const matchingIndices = repeat_days
            .map((day, idx) => Object.keys(day)[0] === wday ? idx : -1)
            .filter(idx => idx !== -1);

        let newRepeatDays;
        if (matchingIndices.length === 0) {
            newRepeatDays = [...repeat_days, { [value]: start_time }];
        } else if (matchingIndices.length === 1) {
            newRepeatDays = repeat_days.filter((_, idx) => idx !== matchingIndices[0]);
        } else {
            return;
        }

        newRepeatDays.sort((a, b) => Object.keys(a)[0] - Object.keys(b)[0]);

        onEventChange({ ...event, repeat_days: newRepeatDays });
    };

  return (
    <>
        <Description>Repeat Weekly On:</Description>
        <div className="weekday-selector">
            {days.map((day, index) => (
                <Button
                    key={index}
                    rounded
                    secondary={!repeat_days.some(day => Object.keys(day)[0] === index.toString())}
                    onClick={() => handleRepeatDay(index)} >
                    {day}
                </Button>
            ))}
        </div>
    </>
  );
};

WeekdaySelector.propTypes = {
  event: PropTypes.object,
  onEventChange: PropTypes.func,
  setUnsavedChanges: PropTypes.func,
};

export default WeekdaySelector;
